import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import {
  campaign as state
} from '../store';

export default createReducer(state, {
  SET_HAS_ACTIVE_CAMPAIGN: (state, { data }) => Immutable({ ...state, hasActiveCampaign: data }),
  SET_CAMPAIGN_INFO: (state, { data }) => Immutable({ ...state, campaignInfo: data }),
  TRIGGER_CAMPAIGN: (state, { data }) => Immutable({ ...state, isCampaignActive: data })
});
